import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFirebaseConfig } from './firebase-config.ts';

const firebaseConfig = getFirebaseConfig();

export const app = initializeApp(firebaseConfig);

// Initialize Analytics for revenue tracking
let analytics: any = null;

// Initialize Analytics asynchronously
(async () => {
  try {
    const supported = await isSupported();

    if (supported) {
      analytics = getAnalytics(app);
    }
  } catch (error) {
    // Analytics initialization failed silently
  }
})();

export { analytics };
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
